<template>
  <div class="dialog" v-if="dialogDisplay">
    <div class="wrap">
      <div class="note">活动需在{{dialogData.message}}客户端操作，确认前往客户端？</div>
      <div class="btnArea">
        <div class="btn btn-href" :class="{is24H: dialogData.from24H}" v-if="dialogData.url" @click="goto">前往</div>
        <div class="btn btn-cancel" @click="close">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogData: Object
  },
  data() {
    return {
      dialogDisplay: false
    }
  },
  methods: {
    close() {
      this.dialogDisplay = false
    },
    goto() {
      if(window.CP) {
        let url = window.location.href;
        const isAndroid = /android/i.test(window.navigator.userAgent);
        isAndroid && /zjxw/i.test(this.dialogData.key) && (url = encodeURIComponent(url));
        CP.open_in_app({
            completed: (data) => {
              if (!data || data.success !== '1')  {
                console.log('未找到APP链接');
              }
            },
            once: true,
            defaultClient: {
                client_code: this.dialogData.key,
                link: url,
            },
            directJump: 1,
            link_url: url
        });
      } else {
        window.location.href = this.dialogData.url
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.dialog
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background: rgba(0, 0, 0, 0.5)
  z-index: 100
  .wrap
    margin: 50% auto 0
    width: 72%
    min-height: 120px
    border-radius: 10px
    background-color: #fff
    text-align: center
    overflow: hidden
    .note
      box-sizing: border-box
      padding: 20px 10px
      min-height: 5em
    .btnArea
      margin-bottom: 10px
      height: 30px
      display: flex
      justify-content: center
      .btn
        width: 36%
        line-height: 30px
        border-radius: 6px
      .btn-href
        margin-right: 10px
        background-color: #4786ff
        color: #fff
        &.is24H
          background-color: #FFDE00
      .btn-cancel
        background-color: #ddd
</style>



// WEBPACK FOOTER //
// src/base/dialog/index.vue